// @flow
import type {ClearAction, CreateAction} from '../../../reducers/reservation';
import { isValidDateObject, getAllDatesInMonth } from '../../../../helpers/time';
export type SetEventTimes = {type: "SET_EVENT_TIMES", eventTimes: object};
export type SetSelectedEvent = {type: "SET_SELECTED_EVENT", event: object};

export type Action = SetEventTimes | SetSelectedEvent | ClearAction | CreateAction;
type State = { eventTimes: Object, selectedListing: object };
let initialState = {
    eventTimes: [],
    selectedListing: {},
    eventTimesByDate: {},
    selectedDateObject: null, //javascript date object
    selectedDate: '',         //string representation of selected date
    selectedChildEvent: null,
    selectedEventTimeObject: null, //selected from eventTimes
    widthForSeriesCalendar: 0, //updated by SeriesDayPicker.  Only used to determine how many months should be displayed for the series calendar
    eventsToday: [],
    fetchedEventsToday: false,
    seriesDatesLoading: false,
    datesLazyLoaded: [], //keeps track of which dates we have requested to prevent duplicate requests
};

export function eventSeries(state: State = initialState, action:Action): State {
    if(action.type === "FETCH_EVENT") {
        let newState = {...state};
        if (action.data && action.data.attributes && typeof action.data.attributes.events === 'object') {
            let event = Object.values(action.data.attributes.events)[0];

            //populate lazy loaded dates to prevent unnecessary requests
            if (event.event && event.event.series && Array.isArray(event.event.series.eventDates)) {
                let uniqueYearMonths = [];
                event.event.series.eventDates.map(date => {
                    let parts = date.split('-');//YYYY-MM-DD
                    if (parts.length === 3) {
                        let yearmonth = parts[0] + '-' + parts[1];
                        if (uniqueYearMonths.indexOf(yearmonth) === -1) {
                            uniqueYearMonths.push(yearmonth);
                        }
                    }
                });
                if (uniqueYearMonths.length) {
                    let allDates = [];
                    uniqueYearMonths.map(yearmonth => {
                        let parts = yearmonth.split('-');
                        allDates = allDates.concat(getAllDatesInMonth(parts[0], +parts[1] - 1));
                    });
                    newState.datesLazyLoaded = [...allDates];
                }
            }
        }
        return newState;
    } else if(action.type === "SET_EVENT_TIMES") {
        let newState = {...state};
        newState.eventTimes = action.eventTimes;
        if(action.date) {
            newState.eventTimesByDate = {...newState.eventTimesByDate};
            newState.eventTimesByDate[new Date(action.date).toISOString()] = action.eventTimes;
        }
        return newState;
    } else if(action.type === "SET_SELECTED_EVENT") {
        let newState = {...state};
        newState.selectedListing = action.data;
        return newState;
    } else if(action.type === "SET_SELECTED_DATE") {
        let newState = {...state};
        newState.selectedDate = action.date;
        return newState;
    } else if(action.type === "SET_SELECTED_DATE_OBJECT") {
        let newState = {...state};
        newState.selectedDateObject = isValidDateObject(action.date) ? action.date : null;
        return newState;
    } else if(action.type === "SET_EVENT_TIME_FOR_DATE") {
        let newState = {...state};
        newState.eventTimesByDate[action.date] = action.eventTimes;
        return newState;
    } else if(action.type === "SET_SELECTED_CHILD_EVENT") {
        let newState = {...state};
        newState.selectedChildEvent = action.id;
        return newState;
    } else if(action.type === "SET_EVENT_TIME_FOR_DATES") {
        let newState = {...state};
        newState.eventTimesByDate = {...newState.eventTimesByDate};
        for (const date in action.eventTimes) {
            newState.eventTimesByDate[new Date(date).toISOString()] = action.eventTimes[date];
        }
        return newState;
    } else if (action.type === "RESERVATION_CLEARED") {
        return {
            ...initialState,
            widthForSeriesCalendar: window.innerWidth,
            eventsToday: state.eventsToday,
            fetchedEventsToday: state.fetchedEventsToday,
            datesLazyLoaded: state.datesLazyLoaded,
        };
    } else if (action.type === "CLEAR_EVENT_TIMES") {
        let newState = {...state};
        newState.eventTimes = [];
        newState.eventTimesByDate = {};
        return newState;
    } else if (action.type === "SET_WIDTH_FOR_SERIES_CALENDAR") {
        let newState = {...state};
        newState.widthForSeriesCalendar = action.width;
        return newState;
    } else if (action.type === "SET_FETCHED_EVENTS_TODAY") {
        let newState = {...state};
        newState.fetchedEventsToday = action.value;
        return newState;
    } else if (action.type === "SET_EVENTS_TODAY") {
        let newState = {...state};
        newState.eventsToday = action.value;
        return newState;
    } else if (action.type === "SET_SELECTED_EVENT_TIME_OBJECT") {
        let newState = {...state};
        newState.selectedEventTimeObject = action.data;
        return newState;
    } else if (action.type === "SET_DATES_LAZY_LOADED") {
        let newState = {...state};
        newState.datesLazyLoaded = [...action.dates];
        return newState;
    } else if (action.type === "REFRESH_EVENT") {
        let newState = {...state};
        newState.datesLazyLoaded = [];
        return newState;
    } else {
        return state;
    }
}
